import CustomerCreate from "../components/customercreate/customercreate"
function CustomerCreatee(){
    return(
        <>
        <CustomerCreate/>
        </>
    )
}
export default CustomerCreatee